<template>
  <div>
    <NormalHeaderLayout header="Request insights">
      <h2>Request additional insights</h2>
      <p>
        If the dashboard displays that your network has offending prefixes, we
        can help you with a personalized service.
      </p>
      <p>
        The APNIC security team can assist you to get more complete information
        about the suspicious traffic that the honeynet sensors have observed
        coming out of your network, and give you recommendations on how to
        secure your users.
      </p>
      <p>
        This service is free; simply submit a request for additional insights
        and the team will contact you shortly.
      </p>

      <RequestForm />

      <h2>Keep tracking the health of your network</h2>
      <p>
        If you want to get more information about the health of your Autonomous
        System (AS), check out these free services.
      </p>
      <h6>Receive reports personalized for your network:</h6>
      <a
        href="https://www.shadowserver.org/what-we-do/network-reporting/get-reports/"
        target="_blank"
        rel="noopener noreferrer"
      >
        ShadowServer Foundation
        <fa icon="external-link-alt" />
      </a>
      <h6>
        Find misconfigured servers in your network that could be used in DDoS
        attacks:
      </h6>
      <a
        href="https://stats.cybergreen.net/country/australia/asn/1221"
        target="_blank"
        rel="noopener noreferrer"
      >
        CyberGreen
        <fa icon="external-link-alt" />
      </a>
      <h6>Verify whether a host is in a block list with:</h6>
      <a
        href="https://www.spamhaus.org/lookup/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Spamhaus
        <fa icon="external-link-alt" />
      </a>

      <h2>Enhance your skills to prevent and mitigate incidents</h2>
      <p>
        APNIC offers free online courses and workshops that help you prevent and
        mitigate the impacts of compromised systems.
      </p>
      <h6>View our upcoming tutorial and workshops:</h6>
      <ul>
        <li>
          <a
            href="https://academy.apnic.net/en/catalog/network-security-1day/"
            target="_blank"
            rel="noopener noreferrer"
          >
            1 day tutorial: Network Security
            <fa icon="external-link-alt" />
          </a>
        </li>
        <li>
          <a
            href="https://academy.apnic.net/en/catalog/network-security-3days/"
            target="_blank"
            rel="noopener noreferrer"
          >
            3 days workshop Network Security
            <fa icon="external-link-alt" />
          </a>
        </li>
        <li>
          <a
            href="https://academy.apnic.net/en/catalog/network-security-5days/"
            target="_blank"
            rel="noopener noreferrer"
          >
            5 days workshop Network Security
            <fa icon="external-link-alt" />
          </a>
        </li>
      </ul>

      <h6>View our webinars courses and study at your own pace:</h6>
      <ul>
        <li>
          <a
            href="https://academy.apnic.net/en/webinar-courses/network-security-fundamentals/"
            target="_blank"
            rel="noopener noreferrer"
          >
            2 hours webinar: Network Security Fundamentals
            <fa icon="external-link-alt" />
          </a>
        </li>
        <li>
          <a
            href="https://academy.apnic.net/en/webinar-courses/packet-analysis-for-network-security/"
            target="_blank"
            rel="noopener noreferrer"
          >
            1 hour webinar: Packet Analysis for Network Security
            <fa icon="external-link-alt" />
          </a>
        </li>
        <li>
          <a
            href="https://academy.apnic.net/en/webinar-courses/learning-from-honeypots/"
            target="_blank"
            rel="noopener noreferrer"
          >
            1/2 hour webinar: Learning from Honeypots
            <fa icon="external-link-alt" />
          </a>
        </li>
        <li>
          <a
            href="https://academy.apnic.net/en/webinar-courses/ddos-attack-prevention/"
            target="_blank"
            rel="noopener noreferrer"
          >
            1 hour webinar: DDoS Attack Prevention
            <fa icon="external-link-alt" />
          </a>
        </li>
      </ul>
    </NormalHeaderLayout>
  </div>
</template>

<script>
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';
import RequestForm from '../components/whatToDo/RequestForm';
export default {
  components: {
    NormalHeaderLayout,
    RequestForm
  }
};
</script>

<style lang="scss" scoped>
h6 {
  margin-bottom: 10px;
}
ul {
  list-style-type: none;

  li {
    margin-bottom: 8px;
  }
}
</style>
